import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import Button from '@material-ui/core/Button';
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTable from "./BasicTable";
import { apiurl } from '../app/prefs.js';
import MonthSelect from "./MonthSelection";
import FilterWindow from "./FilterWindow";
import MUITooltip from "@material-ui/core/Tooltip";

import { Popover, Paper, Dialog, DialogContent } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const VideoIcon = (props) => (
  <svg
    style={{ ...props.style }}
    class="svg-icon"
    width='26px'
    height='26px'
    color='#0b6471'
    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
);

const PlayIcon = () => (
  <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
);

export default function Report024() {
  const [totalData, setTotalData] = React.useState([]);
  const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
  const [totalDataComplete, setTotalDataComplete] = React.useState(false);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const [selectedMonths, setSelectedMonths] = React.useState([]);
  const [opkList, setOpkList] = React.useState([]);
  const [exportDialogOpen, setExportDialogOpen] = React.useState(false);

  const [selectedOPK, setSelectedOPK] = React.useState(undefined);

  const downloadFile = (downloadURL) => {

    getAccessTokenSilently().then((token) => {
      document.body.style.cursor = 'wait';
      const apiUrl = downloadURL
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `AOTM_FK_OPK.xlsx`,
          );
          // Append to html link element page
          document.body.appendChild(link);
          // Start download
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
          document.body.style.cursor = 'auto';
          setExportDialogOpen(false);
        });
    });

  };

  const downloadMulti = (list) => {
    //alert(list);
    downloadFile(`${apiurl}/aotmit/fk_opk/${encodeURIComponent(JSON.stringify(list))}/${startDate.year}/${JSON.stringify(selectedMonths)}/multixlsx`);
  };

  function DateBox(props) {
    return (
      <Autocomplete
        id="combo-box"
        options={dateList}
        value={startDate}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option && option.year.toLocaleString()}
        defaultValue={null}
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.year.toLocaleString() === value.year.toLocaleString();
        }}
        style={{ width: "80px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Rok" />}
        onChange={(event, value) => {
          if (value) {
            setStartDate(value);
            loadData(selectedOPK, value.year, selectedMonths);
          }
        }}
      />
    );
  }

  function OpkBox() {
    return (
      <Autocomplete
        id="opk-combo-box"
        options={opkList}
        value={selectedOPK}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option && (option.opk_id + ' - ' + option.opk_name)}
        defaultValue={null}
        placeholder='Wybierz OPK'
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.opk_name === value.opk_name;
        }}
        style={{ width: "380px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="OPK" />}
        onChange={(event, value) => {
          if (value) {
            setSelectedOPK(value);
            loadData(value.opk_id, startDate.year, selectedMonths);
          }
        }}
      />
    );
  }

  function loadDataBasic(year, months) {
    loadData(selectedOPK.opk_id, year, months)
  }

  const loadData = (opk, year, months) => {
    setTotalDataLoaded(false);
    setTotalDataComplete(false);
    //const apiUrl = `${apiurl}/salariesreport/${opk}/${groups}/${accounts}/${contracts}/${year}/${JSON.stringify(months)}`;
    const apiUrl = `${apiurl}/aotmit/fk_opk/${encodeURIComponent(opk)}/${year}/${JSON.stringify(months)}`
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setTotalData(fetchedData);
          if (
            fetchedData.meta && fetchedData.data && Array.isArray(fetchedData.data)
          ) setTotalDataComplete(true);
          setTotalDataLoaded(true);
        });
    });
  }

  const loadFilters = () => {
    setFiltersLoaded(false);
    const apiUrl = `${apiurl}/salariesreport`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setDateList(fetchedData.YEARS);
          if (fetchedData.YEARS && fetchedData.YEARS.length !== 0) {
            setStartDate(fetchedData.YEARS[fetchedData.YEARS.length - 1]);
            setOpkList([
              ...fetchedData.OPK_LIST
            ]);
            setFiltersLoaded(true);
          }
        });
    });
  }

  React.useEffect(() => {
    let mounted = true;
    //console.log("Main mounted");
    if (mounted) loadFilters();
    return function cleanup() {
      //console.log("Main unmounted");
      mounted = false;
    };
  }, []);

  const [videoListOpen, setVideoListOpen] = React.useState(false);
  const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);
  const [selectedVideo, setSelectedVideo] = React.useState(undefined);

  const handleVideoListClose = () => {
    setVideoListOpen(false)
  };
  const videoData = [
    {
      image: '/open/Raporty_AOTMiT.jpg',
      video: '/open/Raporty_AOTMiT.mp4'
    }
  ];

  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setVideoListOpen(false);
    setVideoPlayDialogOpen(true);
  };

  const VideoList = () => {
    return <div>
      {
        videoData.map(
          (v, i) => {
            return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
              <div style={{ position: 'relative' }}>
                <img src={v.image} alt={'Video nr ' + i} />
                <div style={{
                  position: 'absolute',
                  top: '90px',
                  left: '190px',
                  opacity: '.5',
                  color: 'gray'
                }}>
                  <PlayIcon />
                </div>
              </div>
            </div>
          }
        )
      }
    </div>
  }

  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #9BC0C5)",
          display: "flex",
          height: "55px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Zestawienie AOTMiT FK.OPK
          </Typography>
        </div>
      </div>
      <p style={{ height: "5px" }} />
      {filtersLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
          }}
        >
          <OpkBox />
          <DateBox data={dateList} />
          <MonthSelect setSelectedMonthsFunction={setSelectedMonths} loadDataFunction={loadDataBasic} selectedMonthsProperty={selectedMonths} startDateProperty={startDate} />
          
          <MUITooltip title='Instrukcje video'>
              <Button
                id='video'
                onClick={
                  () => {
                    setSelectedVideo(videoData[0]);
                    setVideoPlayDialogOpen(true);
                  }
                }
                style={{
                  marginTop: "0px",
                  width: "48px",
                  minWidth: "48px",
                  height: "52px",
                  color: "#0B6471",
                  borderRadius: "5px",
                  marginRight: '10px',
                }}
              > <sup style={{ position: 'absolute', color: '#FE8E3C', fontWeight: 'bold', top: '0px', left: '4px' }}>N</sup>
                <VideoIcon
                  style={{ color: '#0B6471', marginTop: '2px', cursor: 'pointer' }}
                />
              </Button>
            </MUITooltip>


          <div style={{ position: "absolute", right: "15px" }}>

            <Button
              style={{ backgroundColor: 'lightgray', marginRight: '5px' }}
              disabled={selectedOPK === undefined ? true : false}
              onClick={
                () => downloadFile(`${apiurl}/aotmit/fk_opk/${encodeURIComponent(selectedOPK.opk_id)}/${startDate.year}/${JSON.stringify(selectedMonths)}/xlsx`)
              }
            >

              Pobierz wybrany OPK
            </Button>

            <Button style={{ backgroundColor: 'lightgray ' }}
              onClick={
                () => setExportDialogOpen(true)
              }
            >
              <sup style={{ color: '#FE8E3C', fontWeight: "bold", fontSize: '16px', marginTop: '-15px' }} > N </sup>
              Pobierz wiele OPK
            </Button>

          </div>

        </div>
      ) : (
        <div>Wczytywanie danych</div>
      )}
      <p style={{ height: "5px" }} />

      {selectedOPK && totalDataComplete ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: totalDataLoaded ? "1" : "0.2",
          }}
        >
          <div
            id="top chart area"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <div
              id="left chart area"
              style={{
                display: "flex",
                flexWrap: "wrap",
                //maxWidth: "840px",
                width: "100%",
                flexDirection: "column",
                flexShrink: 1,
              }}
            >

              <div
                id="top 3 bottom 3 tables area"
                style={{
                  display: "flex",
                  paddingRight: "0px",
                  alignItems: "stretch",
                  flexWrap: "wrap",
                  width: "100%",
                  flexDirection: "row",
                  flexGrow: 1,
                  flexShrink: 1,
                }}
              >
                <BasicTable data={totalData} />

              </div>
            </div>
          </div>
        </div>
      ) : (
        !selectedOPK && (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left"
            }}
            variant="h5"
          >
            Wybierz OPK
          </Typography>
        )
      )}
      {(!totalDataLoaded && selectedOPK) && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: totalData[0] ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={exportDialogOpen}
        onClose={() => setExportDialogOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        //style={{ zIndex: 10000, height: "100%" }}
        style={{ height: "70%" }}
      >
        <Typography
          variant="h6"
          style={{ color: "#0b6471", marginLeft: "30px", marginTop: "10px" }}
        >
          {`Wybierz OPK do wyeksportowania`}
        </Typography>
        <DialogContent>
          <FilterWindow
            closeFn={setExportDialogOpen}
            downloadFn={downloadMulti}
            lookupPlaceholder='Wpisz fragment kodu OPK, którego szukasz' list
            ={opkList.map(i => { return { id: i.opk_id, name: i.opk_name } })} />
        </DialogContent>
      </Dialog>
      <Popover
        id='videoSelectPopOver'
        open={videoListOpen}
        anchorEl={document.getElementById('video')}
        onClose={handleVideoListClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
      >
        <Paper
          style={{
            padding: "10px",
            width: "450px",
            fontFamily: "roboto",
            display: "flex",
            flexDirection: "column",
            height: 'calc(100vh - 234px)',
          }}
        >

          <div
            style={{
              top: "0px",
              display: "flex",
              width: "100%",
              justifyContent: "right"
            }}
          >

            <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => handleVideoListClose()} />

          </div>

          <VideoList />
        </Paper>
      </Popover>

      <Dialog

        maxWidth='90vw'
        open={videoPlayDialogOpen}
        onClose={() => setVideoPlayDialogOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"

      >
        <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
            <button
              onClick={() => {
                const div = document.getElementById('videoControl');
                if (div.requestFullscreen)
                  div.requestFullscreen();
                else if (div.webkitRequestFullscreen)
                  div.webkitRequestFullscreen();
                else if (div.msRequestFullScreen)
                  div.msRequestFullScreen();
              }
              }
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Pełen ekran
            </button>
            <button
              onClick={() => setVideoPlayDialogOpen(false)}
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Zamknij
            </button>
          </div>
          <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
            <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
            Video control not supported by browser
          </video>

        </DialogContent>
      </Dialog>
    </div>
  );
}
